<h1 mat-dialog-title>Update output formula &mdash; EV</h1>
<mat-dialog-content class="dialog-body">
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Name</mat-label>
    <input matInput [formControl]="nameControl" type="text" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-field">
    <mat-label>EV conventions</mat-label>
    <mat-select [formControl]="evConventionIdsControl" multiple>
      @for (fc of evConventions; track fc.id) {
        <mat-option [value]="fc.id">{{ fc.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (needsStillsSpec) {
    <div class="media-section">
      <div class="media-section-header">
        <span class="media-section-title">
          <mat-icon inline="true">image</mat-icon>Stills spec
        </span>
      </div>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Stills file specification</mat-label>
        <mat-select [formControl]="stillsSpecIdControl">
          @for (fs of stillsFileSpecifications; track fs.id) {
            <mat-option [value]="fs.id">{{ fs.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  @if (needsVideosSpec) {
    <div class="media-section">
      <div class="media-section-header">
        <span class="media-section-title">
          <mat-icon inline="true">movie</mat-icon>Videos spec
        </span>
      </div>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Videos file specification</mat-label>
        <mat-select [formControl]="videosSpecIdControl">
          @for (fs of videosFileSpecifications; track fs.id) {
            <mat-option [value]="fs.id">{{ fs.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Reason</mat-label>
    <mat-select [formControl]="reasonControl">
      @for (r of selectableReasons; track r) {
        <mat-option [value]="r">{{ reasonLabel(r) }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (isOther) {
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Detail</mat-label>
      <input matInput [formControl]="detailControl" type="text" />
    </mat-form-field>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    [disabled]="!canSave"
    (click)="save()"
  >
    Save
  </button>
</mat-dialog-actions>
